import { PropertiesPanelSection } from "@skilitics/designer-ui-components";
import { useFormatMessage } from "@skilitics/localization";

import { CssBindingsPropertyPanelSection, useCssBindings } from "../bindings";
import { CustomCssForm, type CustomCssFormValues } from "./CustomCssForm";
import { useEditingCss } from "./EditingCssPropertiesContext";

type Props = {
  config: Partial<CustomCssFormValues>;
  onConfigChange: (newConfig: Partial<CustomCssFormValues>) => void;
};

export const AdvancedProperties = ({ config, onConfigChange }: Props) => {
  const formatMessage = useFormatMessage(formatStrings);
  const { bindings } = useCssBindings();
  const { isEditingElementState } = useEditingCss();
  return (
    <PropertiesPanelSection
      title={formatMessage("sectionHeading")}
      collapsible
      defaultCollapsed={config.customCss === "" && !bindings.length}
      data-test="advanced-css-section"
    >
      <CssBindingsPropertyPanelSection />

      {!isEditingElementState && (
        <div style={{ marginTop: "15px" }}>
          <CustomCssForm initialValues={{ customCss: config.customCss ?? "" }} onSubmit={onConfigChange} />
        </div>
      )}
    </PropertiesPanelSection>
  );
};

const formatStrings = {
  sectionHeading: {
    en: "Advanced",
  },
};
